import { render, staticRenderFns } from "./CommsLog.vue?vue&type=template&id=44c30a18&"
import script from "./CommsLog.vue?vue&type=script&lang=js&"
export * from "./CommsLog.vue?vue&type=script&lang=js&"
import style0 from "./CommsLog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CommsLog.vue"
export default component.exports